import React from "react";
import './joinUs.css';
import joinUs from '../../template/images/join_us.png';
import { useNavigate } from "react-router-dom";


const JoinUs = () => {
    const navigate = useNavigate();

    // const chatWithUs = () => {
    //     console.log('Chat with us')
    // }

    const contactUs = () => {
        window.location.href = "mailto:info@finlabsindia.org";
    }

    const enquiry = () => {
        navigate('/GeneralEnquiry')
    }

const redirectSocial = (path) => {
    if(path == 'facebook'){
        window.open('https://www.facebook.com/finlabsind', '_blank');
    }else if(path == 'instagram'){
        window.open('https://www.instagram.com/finlabsindia', '_blank');
    }else if(path == 'linkedin'){
        window.open('https://www.linkedin.com/uas/login?session_redirect=%2Fcompany%2F14438243%2F', '_blank');
    }else{
        window.open('https://x.com/i/flow/login?redirect_after_login=%2FIndiaFinlabs', '_blank');
    }
}


    return (
        <React.Fragment>
            <div className="joinUs_main">
                <div className="container">
                    {/* <div className="joinUs__title_sec">
                        <h2 className="joinUs_title">Join Us</h2>
                    </div> */}
                    <div className="joinus_inner">
                        <div className="row">
                            <div className="col-12">
                                <div className="joinus_social">
                                    <div className="social_outer">
                                        <div className="home_social_icon">
                                        <i class="fa-solid fa-pen at"></i>
                                        </div>
                                        <div className="social" onClick={()=>contactUs()}>   
                                            <span className="social_text">WRITE TO US</span>
                                        </div>
                                    </div>

                                    <div className="social_outer social_2">
                                        <div className="home_social_icon">
                                        <i class="fa-regular fa-file-lines at"></i>
                                        </div>
                                        <div className="social" onClick={()=>enquiry()}>
                                            <span className="social_text">ENQUIRE</span>
                                        </div>
                                    </div>

                                    {/* <div className="social_outer social_3">
                                        <div className="home_social_icon">
                                        <i class="fa-solid fa-at at"></i>
                                        </div>
                                        <div className="social" onClick={()=>enquiry()}>
                                            <span className="social_text">ENQUIRE</span>
                                        </div>
                                    </div> */}

                                </div>
                                <div className="joinUs_img">
                                    <img src={joinUs}></img>
                                </div>
                                <div className="img_description">
                                    <p>Unlock your potential with Finlabs Learning Hub. Whether you're an individual looking to advance your career or an organization aiming to stay competitive, our tailored learning solutions will help you achieve your goals. Start your journey towards success with us and transform your skills, transform your life. </p>
                                    <div className="joinus_btn_area">
                                        <p className="join_community_text">Join Our Community</p>
                                    </div>
                                    <div className="join_social_icon_main">
                                        <div className="social_icon f_color" onClick={()=>redirectSocial('facebook')}>
                                            <i class="fa-brands fa-facebook-f facebook_c"></i>
                                        </div>
                                        <div className="social_icon i_color" onClick={()=>redirectSocial('instagram')}>
                                            <i class="fa-brands fa-instagram insta_c"></i>
                                        </div>
                                        <div className="social_icon l_color" onClick={()=>redirectSocial('linkedin')}>
                                            <i class="fa-brands fa-linkedin-in linked_c"></i>
                                        </div>
                                        <div className="social_icon t_color" onClick={()=>redirectSocial('twitter')}>
                                            <i class="fa-brands fa-twitter twitter_c"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default JoinUs;